export default "__VITE_ASSET__DMI3f9dR__"